import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './trading-journal';
import UsageAnalytics from './UsageAnalytics';
import JournalErrorBoundary from './JournalErrorBoundary';

const Preview = process.env.REACT_APP_WORKSPACE_PREVIEW === 'true' ? lazy(() => import('./ExperiencePreview')) : null;
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <JournalErrorBoundary>{Preview ? <Suspense fallback={<div style={{background:"#111313",minHeight:"100vh"}}/>}><Preview/></Suspense> : <App />}</JournalErrorBoundary>
    {!Preview && !['/auth/action','/support','/account','/admin','/checkout','/billing-preview'].some(path=>window.location.pathname.startsWith(path)) && <UsageAnalytics />}
  </React.StrictMode>
);
